<template>
  <first />
</template>

<script>
import first from "./components/first.vue";

export default {
  name: "App",
  components: {
    first
  }
};
</script>

<style lang="scss">
@function strip-unit($value) {
  @return $value / ($value * 0 + 1);
}
@mixin fluid-type($min-vw, $max-vw, $min-font-size, $max-font-size) {
  $u1: unit($min-vw);
  $u2: unit($max-vw);
  $u3: unit($min-font-size);
  $u4: unit($max-font-size);
  @if $u1 == $u2 and $u1 == $u3 and $u1 == $u4 {
    & {
      font-size: $min-font-size;
      @media screen and (min-width: $min-vw) {
        font-size: calc(
          #{$min-font-size} + #{strip-unit($max-font-size - $min-font-size)} *
            ((100vw - #{$min-vw}) / #{strip-unit($max-vw - $min-vw)})
        );
      }
      @media screen and (min-width: $max-vw) {
        font-size: $max-font-size;
      }
    }
  }
}
$mod_1: 1.2;
$mod_2: 1.5;
$min_width: 320px;
$max_width: 1200px;
$min_font: 10px;
$max_font: 20px;
h1 {
  font-size: $mod_1 * $mod_1 * $mod_1 * $mod_1 * 1rem;
  @include fluid-type(
    $min_width,
    $max_width,
    $mod_1 * $mod_1 * $mod_1 * $min_font,
    $mod_2 * $mod_2 * $mod_2 * $min_font
  );
}
li {
  font-size: $mod_1 * $mod_1 * $mod_1 * 1rem;
  @include fluid-type(
    $min_width,
    $max_width,
    $mod_1 * $mod_1 * $mod_1 * $min_font,
    $mod_2 * $mod_2 * $mod_2 * $min_font
  );
}
p {
  font-size: $mod_1 * $mod_1 * 1rem;
  @include fluid-type(
    $min_width,
    $max_width,
    $mod_1 * $mod_1 * $min_font,
    $mod_2 * $mod_2 * $min_font
  );
}
@font-face {
  font-family: "RobotoMono-Regular";
  src: url("../src/assets/fonts/RobotoMono-Regular.eot");
  src: url("../src/assets/fonts/RobotoMono-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../src/assets/fonts/RobotoMono-Regular.otf") format("opentype"),
    url("../src/assets/fonts/RobotoMono-Regular.svg") format("svg"),
    url("../src/assets/fonts/RobotoMono-Regular.ttf") format("truetype"),
    url("../src/assets/fonts/RobotoMono-Regular.woff") format("woff"),
    url("../src/assets/fonts/RobotoMono-Regular.woff2") format("woff2");
  font-display: swap;
}
input {
  all: unset;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
::-webkit-scrollbar {
  display: none;
}
::scrollbar {
  display: none;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgb(163, 203, 206);
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgb(163, 203, 206);
}

::placeholder {
  color: rgb(163, 203, 206);
}
body {
  line-height: 1.75em;
  width: 100vw;
  max-width: 100%;
  min-height: 100vh;
  min-height: stretch;
}
#app {
  position: absolute;
  width: 100vw;
  max-width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  min-height: 100vh;
  min-height: stretch;
  line-height: 1.75em;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  font-family: "RobotoMono-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(236, 236, 236);
  animation: bgcolor 7s infinite ease-in-out;
  padding-top: 0.5em;
  font-size: $mod_1 * $mod_1 * $mod_1 * $mod_1 * 1rem;
  @include fluid-type(
    $min_width,
    $max_width,
    $mod_1 * $mod_1 * $mod_1 * $min_font,
    $mod_2 * $mod_2 * $mod_2 * $min_font
  );
  @keyframes bgcolor {
    0% {
      background-color: rgb(29, 126, 133);
    }
    33% {
      background-color: rgb(27, 118, 121);
    }
    66% {
      background-color: rgb(27, 114, 119);
    }
    100% {
      background-color: rgb(29, 126, 133);
    }
  }
  @keyframes ilmesty {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes leiju {
    0% {
      -webkit-transform: translate(0) rotate(0.1deg);
      -moz-transform: translate(0) rotate(0.1deg);
      transform: translate(0) rotate(0.1deg);
    }
    50% {
      -webkit-transform: translate(-0.25em, -0.25em) rotate(0.3deg);
      -moz-transform: translate(-0.25em, -0.25em) rotate(0.3deg);
      transform: translate(-0.25em, -0.25em) rotate(0.3deg);
    }
    100% {
      -webkit-transform: translate(0) rotate(0.1deg);
      -moz-transform: translate(0) rotate(0.1deg);
      transform: translate(0) rotate(0.1deg);
    }
  }
  @keyframes kolmio {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @keyframes ehdotusAvaudu {
    0% {
      max-height: 0;
    }
    100% {
      max-height: 5em;
    }
  }
  @keyframes ehdotusSulkeudu {
    0% {
      max-height: 5em;
    }
    100% {
      max-height: 0;
      color: transparent;
    }
  }
  @keyframes tuloksetAvaudu {
    0% {
      height: 0;
    }
    100% {
      height: 100%;
    }
  }
  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
  html {
    @include fluid-type($min_width, $max_width, $min_font, $max_font);
    line-height: 1.75em;
    height: -webkit-fill-available;
  }
  body {
    margin: 0;
  }
  main {
    display: block;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  a {
    background-color: transparent;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }
  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }
  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }
  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  details {
    display: block;
  }
  summary {
    display: list-item;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none;
  }
}
</style>
